export default __webpack_public_path__ + "assets/b6f5cba1396dffce8d5baeb0edd330fe.png";